import React, { useState, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import { ImageWithBasePath } from 'Core/components';
import ToastService from 'Service/toast-service';
import { PartService } from 'Service/api/part-service';
import { useDispatch, useSelector } from 'react-redux';
import { actions as partActions } from './store/slice';
import { selectUploadDrawingVisible } from './store/selectors';
import { showToast as displayToast } from 'Core/redux/toast/slice';
import { Download, FileText } from 'react-feather';
import { ButtonGroup } from 'react-bootstrap';

const { setUploadDrawingVisible } = partActions;

const styles = {
  removeButton: {
    position: 'absolute',
    top: '8px',
    right: '8px',
    width: '20px',
    height: '20px',
    borderRadius: '50%',
    backgroundColor: '#ff4444',
    color: 'white',
    border: 'none',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '14px',
    opacity: 0,
    transition: 'opacity 0.2s',
  },
  fileName: {
    // position: 'absolute',
    bottom: 0,
    left: 0,
    right: 0,
    backgroundColor: 'rgba(255, 255, 255, 0.9)',
    padding: '6px 8px',
    fontSize: '12px',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  }
}
const UploadDrawing = ({ onUploadSuccess, onClose, fileUrl }) => {
  const [file, setFile] = useState(null);
  const [filePath, setFilePath] = useState('');
  const [fileDetail, setFileDetail] = useState(null);
  const dispatch = useDispatch();
  const [dragActive, setDragActive] = useState(false);
  const openPopup = useSelector(selectUploadDrawingVisible);
  
  const inputRef = useRef(null);
  const [uploading, setUploading] = useState(false);
  const [showToast, setShowToast] = useState(false);
  const [currentToast, setCurrentToast] = useState(null);

  useEffect(() => {

    if (!fileUrl) return;
    
    setFilePath(fileUrl);
    const filenameList = fileUrl.split('.');
    setFileDetail(prevState => {
      return {
      ...(prevState ? prevState : {}),
      name: prevState && prevState.name ? prevState.name : (filenameList.length ? filenameList[filenameList.length - 2] : '')
    }});

  }, [fileUrl]);
  // Handle modal close
  const handleClose = () => {
    setFile(null);
    setFileDetail(null);
    setFilePath(null);
    if (inputRef.current) {
      inputRef.current.value = '';
    }

    if (onClose) {
      onClose({
        filePath: ''
      });
    }
  };

  const handleFile = selectedFile => {
    if (selectedFile) {
      // Validate file extension
      const fileName = selectedFile.name.toLowerCase();
      if (!fileName.endsWith('.xlsx') && !fileName.endsWith('.xls')) {
        dispatch(displayToast({
          message: 'Please select a valid Excel file (.xlsx or .xls)',
          type: 'danger',
        }));
        return;
      }

      // Validate file size (e.g., 10MB)
      const maxSize = 10 * 1024 * 1024; // 10MB in bytes
      if (selectedFile.size > maxSize) {
        dispatch(displayToast({
          message: 'File size should be less than 10MB',
          type: 'danger',
        }));
        return;
      }

      setFile(selectedFile);
      setFileDetail(selectedFile);
    }
  };

  // Handle click on the upload area
  const handleClick = () => {
    inputRef.current.click();
  };

  // Handle file selection through input
  const handleChange = e => {
    e.preventDefault();
    if (e.target.files && e.target.files[0]) {
      setFilePath(null);
      handleFile(e.target.files[0]);
    }
  };

  // Handle drag events
  const handleDrag = e => {
    e.preventDefault();
    e.stopPropagation();
    if (e.type === 'dragenter' || e.type === 'dragover') {
      setDragActive(true);
    } else if (e.type === 'dragleave') {
      setDragActive(false);
    }
  };

  // Handle drop event
  const handleDrop = e => {
    e.preventDefault();
    e.stopPropagation();
    setDragActive(false);
    if (e.dataTransfer.files && e.dataTransfer.files[0]) {
      handleFile(e.dataTransfer.files[0]);
    }
  };

  const handleUpload = async e => {
    e.preventDefault();

    if (!file) {
      dispatch(displayToast(
        {
          message: 'Please select a file first',
          type: 'danger',
        }));
      //   ToastService.error('Please select a file first', {
      //     position: ToastService.positions.TOP_RIGHT,
      //     onClose: handleCloseToast,
      //   }),
      // );
      return;
    }

    try {
      setUploading(true);
      const formData = new FormData();
      formData.append('file', file);
      formData.append('UploadCategory', 'Part-UploadDrawing');
      const response = await PartService.uploadDrawing(formData);
      console.log('resp ->', response)
      if (response.status == '200') {
        setFile(null);
        if (inputRef.current) {
          inputRef.current.value = '';
        }

        // Notify parent component
        if (onUploadSuccess) {
          const fPath = response.response ? response.response.relativePath : '';
          setFilePath(fPath);
          onUploadSuccess({
            filePath: fPath
          });
        }
      } else {
        //alert(response.errorMessage?.message || 'Failed to upload parts');
        dispatch(displayToast({
          message: response.errorMessage?.message || 'Failed to upload parts',
          type: 'danger',
        }));

        console.error('Error upload parts:', response.errorMessage?.message);
      }
    } catch (error) {
      // alert(error.message || 'Error uploading file');
      dispatch(displayToast({
        message: error.message || 'Error uploading file',
        type: 'danger',
      }));
    } finally {
      setUploading(false);
    }
  };

  const handleCloseToast = () => {
    setShowToast(false);
    setCurrentToast(null);
  };

  // const downloadImageFn = (e, img) => {
  //   e.stopPropagation();
  //   downloadImage(img);
  // }

  const showUploadedFile = () => (
    filePath ? <div
      style={styles.previewItem}
      onMouseEnter={e => {
        const removeBtn = e.currentTarget.querySelector('.remove-btn');
        if (removeBtn) removeBtn.style.opacity = '1';
      }}
      onMouseLeave={e => {
        const removeBtn = e.currentTarget.querySelector('.remove-btn');
        if (removeBtn) removeBtn.style.opacity = '0';
      }}
    >
      <div className="d-flex-centered-h col-6 flex-wrap">

        <div className='position-relative'>
          <FileText size={60} />
          <button
            className="remove-btn"
            onClick={handleClose}
            style={styles.removeButton}
            title="Remove file"
          >
            ×
          </button>
          {/* <ButtonGroup className='downloadImageBtn' size="sm">
                <Button variant="light" onClick={(e) => downloadImageFn(e, filePath)}>
                  <Download size={16} />
                </Button>,
              </ButtonGroup> */}
        </div>
        <div style={styles.fileName}>{fileDetail ? fileDetail.name : ''}</div>
      </div>

    </div> : null
  )

  return (<div className="" id="upload-drawings">
    <form onSubmit={handleUpload}>
      <div className="row">
        <div className="col-lg-12">
          <div className="input-blocks image-upload-down">
            {/* <label>Upload Excel File</label> */}
            <div style={{ border: 'none' }}
              className={`image-upload download ${dragActive ? 'drag-active' : ''}`}
              onClick={handleClick}
              onDragEnter={handleDrag}
              onDragLeave={handleDrag}
              onDragOver={handleDrag}
              onDrop={handleDrop}
            >
              {/* Hidden file input */}
              <input
                ref={inputRef}
                type="file"
                accept=".xlsx,.xls"
                onChange={handleChange}
                className="d-none"
              />

              <div className="image-uploads">
                <ImageWithBasePath src="assets/img/download-img.png" alt="img" />
                {file ? (
                  <div className="selected-file">
                    <h4>Selected File: {file.name}</h4>
                    <p>Size: {(file.size / 1024 / 1024).toFixed(2)} MB</p>
                  </div>
                ) : (
                  <h4>
                    Drag and drop an <span>excel file to upload</span>
                    <br />
                    <span className="small">or click to select</span>
                  </h4>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <div className="d-flex justify-content-between">
        <div className="d-flex-centered-h col-6">
          {showUploadedFile()}
        </div>
        <div className="col-6 d-flex justify-content-end align-items-end">
          <button type="button" className="btn btn-cancel me-2" data-bs-dismiss="modal">
            Cancel
          </button>
          <button type="submit" className="btn btn-submit" disabled={!file || uploading}>
            {uploading ? 'Uploading...' : 'Submit'}
          </button>
        </div>
      </div>

    </form>
  </div>
  );
};

UploadDrawing.propTypes = {
  onUploadSuccess: PropTypes.func,
  onClose: PropTypes.func,
};
export default UploadDrawing;
